import { PayloadAction, createSlice } from '@reduxjs/toolkit';

import { MCTChartType } from 'components/DevicesDetail/MCT/ChartType/MCTChartType';

export interface DeviceDetailPageState {
  currentMCTChartType: MCTChartType;
}

export const initialState: DeviceDetailPageState = {
  currentMCTChartType: MCTChartType.SimpleChart,
};

const devicesDetailPageSlice = createSlice({
  name: 'DevicesDetailPages',
  initialState,
  reducers: {
    setCurrentMCTChartType(state, action: PayloadAction<MCTChartType>) {
      state.currentMCTChartType = action.payload;
    },
  },
});

export const { setCurrentMCTChartType } = devicesDetailPageSlice.actions;

export default devicesDetailPageSlice.reducer;
